// src/utils/promoChrome.js
// Support for the catalog Deck Builder banner/toast and Discord invite.

export const CATALOG_ROUTE = '/catalog';
export const TRY_NEW_DECK_PATH = '/catalog/';
export const GRID_PATH = '/grid/';
export const DISCORD_INVITE_URL = 'https://discord.gg/8PyzHdDc4v';

export const TRY_NEW_TOAST_STORAGE_KEY = 'metaPtcg.tryNewDeckToast.dismissed';
export const DISCORD_BAR_STORAGE_KEY = 'metaPtcg.discordInviteBar.v2.dismissed';

function readFlag(key) {
    try {
        return window.localStorage.getItem(key) === '1';
    } catch {
        return false;
    }
}

function writeFlag(key, value) {
    try {
        if (value) {
            window.localStorage.setItem(key, '1');
        } else {
            window.localStorage.removeItem(key);
        }
    } catch {
        // Ignore quota / private-mode failures; UI still works for this session.
    }
}

export function getCurrentPath() {
    try {
        return window.location.pathname || '/';
    } catch {
        return '/';
    }
}

function normalizePath(pathname = getCurrentPath()) {
    return String(pathname || '/').replace(/\/+$/, '') || '/';
}

export function isCatalogPath(pathname = getCurrentPath()) {
    const path = normalizePath(pathname);
    return path === CATALOG_ROUTE || path.startsWith(`${CATALOG_ROUTE}/`);
}

export function isGridPath(pathname = getCurrentPath()) {
    return normalizePath(pathname) === '/grid';
}

export function shouldShowTryNewBanner(pathname = getCurrentPath()) {
    return !isCatalogPath(pathname);
}

export function isTryNewToastDismissed() {
    return readFlag(TRY_NEW_TOAST_STORAGE_KEY);
}

export function dismissTryNewToast() {
    writeFlag(TRY_NEW_TOAST_STORAGE_KEY, true);
}

export function shouldShowTryNewToast(pathname = getCurrentPath()) {
    return shouldShowTryNewBanner(pathname) && !isTryNewToastDismissed();
}

export function isDiscordBarDismissed() {
    return readFlag(DISCORD_BAR_STORAGE_KEY);
}

export function dismissDiscordBar() {
    writeFlag(DISCORD_BAR_STORAGE_KEY, true);
}

export function shouldShowDiscordBar() {
    return !isDiscordBarDismissed();
}

export function getPromoChromeDebugState() {
    return {
        path: getCurrentPath(),
        banner: shouldShowTryNewBanner(),
        toast: shouldShowTryNewToast(),
        toastDismissed: isTryNewToastDismissed(),
        discord: shouldShowDiscordBar(),
        discordDismissed: isDiscordBarDismissed()
    };
}
